import { SET_ERROR, SET_USERS } from "../actionTypes";

const initial_state = {
  users: []
}

export default function usersReducer(state = initial_state, action) {
  switch (action.type) {
    case SET_USERS:
      return {...state, users: action.payload}
    default:
      return state
  }
}